import { ApiUser } from '@vend/types'
import { LineItemUser } from './line-item'

export const convertApiUserToLineItemUser = (user: ApiUser): LineItemUser => {
  return {
    id: user.id,
    email: user.email,
    username: user.username,
    displayName: user.display_name,
  }
}

/**
 * Whether a user matches a search term, compared case-insensitively against
 * their username, display name and email.
 */
export const matchesUserSearch = (
  user: ApiUser,
  searchTerm: string
): boolean => {
  const normalizedSearchTerm = searchTerm.toLowerCase()

  if (user.display_name.toLowerCase().includes(normalizedSearchTerm)) {
    return true
  }

  if (user.email?.toLowerCase().includes(normalizedSearchTerm)) {
    return true
  }

  if (user.username.toLowerCase().includes(normalizedSearchTerm)) {
    return true
  }

  return false
}
